export const ORDER_HEADER_DATA_I18N_NAMESPACE = 'order-header-data' as const;
